import { topics } from '@/mocks/homeData';

export default function Topics() {
  return (
    <section id="topics" className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 text-center">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#media');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-4 py-2 bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 rounded-full transition-all duration-200 group cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${topic.icon} text-xs text-primary-400 group-hover:text-primary-500 transition-colors`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}